module.exports = __webpack_public_path__ + "static/media/18-d-calendar.89a41e33.png";